// TODO: remove eslint-disables and ts-ignore
/* eslint-disable react/no-unstable-nested-components */
import React, { useContext, useState, useEffect } from 'react';
import { Dropdown, MenuProps, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faPlus, faFileCsv } from '@fortawesome/free-solid-svg-icons';
import { LoggedInUserContext, SearchPaneResultsContext, AttributesContext } from 'common/contexts';
import { getPrivilegesFromUser } from 'common/utils/user';
import { simpleFetch } from 'common/utils/http';
import { flattenAttributes } from 'common/components/Header/components/utils';
import { Genre, Section } from 'common/constants/types';
import { ADD_PERSON, EXPORT_CSV_ACCESS } from 'common/constants/privileges';
import { Link } from 'react-router-dom';
import Icon from 'common/components/Icon';
import FieldsPickerModal from './FieldsPickerModal';
import SelectPeopleByAttribute from './SelectPeopleByAttribute';
import SpecialRecordModal from './SpecialRecordModal';
import styles from './SearchHeader.module.scss';

interface Props {
  contactCount: number;
  toggleMultiSelectView: () => void;
}

const SearchHeader = ({ contactCount, toggleMultiSelectView }: Props) => {
  const [showSpecialRecordModal, setShowSpecialRecordModal] = useState(false);
  const [isExportCSVModalOpen, setIsExportCSVModalOpen] = useState(false);
  const [fields, setFields] = useState<string[]>([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const { loggedInUser } = useContext(LoggedInUserContext);
  const { sortedSearchResults } = useContext(SearchPaneResultsContext);
  const { attributes } = useContext(AttributesContext);
  const privileges = getPrivilegesFromUser(loggedInUser);

  const addPersonItems: MenuProps['items'] = [
    {
      label: <Link to="/users/bulk-add">Add Contact</Link>,
      key: 'add',
      icon: <Icon type="singleUser" />,
    },
    {
      label: <div>Add Special Record</div>,
      onClick: () => setShowSpecialRecordModal(true),
      key: 'special',
      icon: <Icon type="multiUser" />,
    },
  ];

  const { sections }: Pick<Genre, 'sections'> = attributes.genres.reduce<Pick<Genre, 'sections'>>(
    (prev, curr) => ({
      sections: [...prev.sections, ...curr.sections],
    }),
    { sections: [] }
  );

  const { attribute_types }: Pick<Section, 'attribute_types'> = sections.reduce<
    Pick<Section, 'attribute_types'>
  >(
    (prev, curr) => ({
      attribute_types: [...prev.attribute_types, ...curr.attribute_types],
    }),
    { attribute_types: [] }
  );

  const toggleExportCSVModalOpen = () => {
    setIsExportCSVModalOpen(!isExportCSVModalOpen);
    setSelectedFields([]);
  };
  useEffect(() => {
    const propagateAttributeTypes = async () => {
      try {
        const response = await simpleFetch('/api/v1/attributes');
        setFields((flattenAttributes(response) as { name: string }[]).map(elem => elem.name));
      } catch (e) {
        message.error(JSON.stringify(e));
      }
    };
    if (!fields.length) {
      propagateAttributeTypes();
    }
  }, [fields, setFields]);

  return (
    <>
      <SpecialRecordModal isOpen={showSpecialRecordModal} toggle={setShowSpecialRecordModal} />
      <div className={styles.container}>
        <div className={styles.text}>
          {contactCount} Contact{contactCount === 1 ? '' : 's'}
        </div>
        <div className={styles.buttons}>
          {privileges.includes(EXPORT_CSV_ACCESS) ? (
            <div>
              <FontAwesomeIcon
                className={styles.icon}
                cursor="pointer"
                icon={faFileCsv}
                onClick={() => toggleExportCSVModalOpen()}
              />
              <FieldsPickerModal
                attribute_types={attribute_types}
                fields={fields.sort()}
                ids={sortedSearchResults.map(person => person.person_id)}
                isOpen={isExportCSVModalOpen}
                selectedFields={selectedFields}
                setSelectedFields={setSelectedFields}
                toggle={toggleExportCSVModalOpen}
              />
            </div>
          ) : null}
          <div className={styles.button}>
            <FontAwesomeIcon
              className={styles.icon}
              cursor="pointer"
              icon={faList}
              onClick={toggleMultiSelectView}
            />
          </div>
          <div className={styles.button}>
            <SelectPeopleByAttribute />
          </div>
          {privileges.includes(ADD_PERSON) && (
            <div className={styles.button}>
              <Dropdown menu={{ items: addPersonItems }} trigger={['click']}>
                <span>
                  <FontAwesomeIcon className={styles.icon} cursor="pointer" icon={faPlus} />
                </span>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchHeader;
